export default __webpack_public_path__ + "static/media/Framer.f5ea2307.svg";